export var convertFromUxLangToCss = function convertFromUxLangToCss() {
  var ux = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ux.toLowerCase().replace('.', '_');
};

export var convertFromCssToUxLang = function convertFromCssToUxLang() {
  var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return css.toUpperCase().replace('_', '.');
};
//# sourceMappingURL=Utils.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Typography/Utils.js